import { createFileRoute } from '@tanstack/react-router';

import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';

import { LocalSearchGrid } from 'features/reports/LocalSearchGrid';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/lsg/')({
  component: LocalSearchGridRoute
});

function LocalSearchGridRoute() {
  const { id } = Route.useParams();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.LOCAL_SEARCH_GRID}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.LOCAL_SEARCH_GRID}
    >
      <LocalSearchGrid locationId={id} />
    </ToolAccessGate>
  );
}
